import RequiredInfo from 'Components/Client/Cases/CaseDetails/RequiredInfo'
import React, { useContext, useEffect, useState } from 'react'
import MakeDownloadblePdf from './MakeDownloadblePdf'
import DownloadIcon from 'Components/Icons/DownloadIcon'
import { Context } from 'Context/Context';
import { TEAMUP_ENABLED } from 'Constants';
import { GoQuestion } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
import { getNetWorth } from 'Utils';

function RequiredInfoOnProfContent({caseDetails, hasAccess, attorney}) {
    const [requiredCaseInfo, setRequiredCaseInfo] = useState({...caseDetails});
    const {userDetails} = useContext(Context);
    const navigate = useNavigate();
    const [onHover, setOnHover] = useState(false);
    const userInfo = attorney ? attorney.userId : userDetails;

    useEffect(()=>{
        if(!hasAccess)
        {
            setRequiredCaseInfo({...caseDetails, isOwnerAnonymous:'', contactEmail: '', contactPhone:'', firstName:'', lastName:'', adversePartyName: ''})
        }
        else
        {
            setRequiredCaseInfo({...caseDetails})
        }
    },[caseDetails, hasAccess])
  return (
        <div className=' relative text-xs lg:text-sm shadow-xl border p-2 lg:p-4 w-full lg:mr-4'>
            <div className=' font-bold text-sm lg:text-md text-green-700 mb-6 underline'>Basic Case details of {caseDetails?.caseNumber} </div>
                <RequiredInfo
                caseDetails={requiredCaseInfo}
                />
                {caseDetails?.isPostedBySelf &&
                    <div className={"flex mb-4 grid grid-cols-3  gap-2" + (!userInfo.isActiveSubscription ? " opactiy-25" : '')}>

                        <div className=' text-gray-600 col-span-2 '>Are you the plaintiff in this case or are you a family member/friend/advisor seeking an attorney on that person's behalf?</div>
                            <div className='col-span-1'>{
                           
                        (caseDetails?.isPostedBySelf === "yes" ? "I am the potential plaintiff creating this case" : "I am a close family member/friend/advisor of the potential plaintiff")
                            }
                        </div>
                    </div>
                    }
                <div className={' lg:p-2 relative flex  flex-col rounded'+(!userInfo.isActiveSubscription ? ' bg-purple-50' : '')}
                 onMouseEnter={() => setOnHover(true)}
                 onMouseLeave={() => setOnHover(false)}
                 onClick={() => !userInfo.isActiveSubscription ? navigate('/attorney/subscription') : ''}
                >
                   
                    {
                        onHover && !userInfo?.isActiveSubscription &&

                        <>
                        
                        <div className='absolute z-20 bg-purple-100 text-gray-900 justify-center flex w-full  rounded font-medium border border-purple-200 top-10  left-0 p-2'>
                        {/* <div className="border-[14px] border-t-0 border-r-transparent border-l-transparent border-b-sky-200 h-0 w-0 absolute -top-3 right-0"></div>  */}

                            <div className='text-xs font-bold'>You should be subscribed to be able to see this content</div>
                            </div></>
                    }
                    {caseDetails?.isClassAction &&
                    <div className={"flex mb-4 grid grid-cols-3  gap-2" }>
                        <div className=' text-gray-600 col-span-2'>Is this a class action lawsuit?</div>
                            <div className={"" +(userInfo?.isActiveSubscription  ? '': 'blur-sm' )}>
                            {userInfo?.isActiveSubscription  ?
                            (caseDetails?.isClassAction === "yes" ? "Yes" : "No")
                            :
                            "Test"}
                        </div>
                    </div>}
                    {caseDetails?.isEntity &&
                    <div className={"flex mb-4 grid grid-cols-3  gap-2"}>

                        <div className=' text-gray-600 col-span-2'>Is this against an entity or an individual? </div>
                            <div className={"col-span-1 " +( userInfo?.isActiveSubscription  ? '': 'blur-sm') }>{
                            userInfo?.isActiveSubscription  ?
                            (caseDetails?.isEntity === "yes" ? "Entity" : "Individual")
                        :
                        "Testvalue"}
                        </div>
                    </div>
                    }
                    {caseDetails?.defendant &&
                    <div className={"flex mb-4 grid grid-cols-3 gap-2 "}>

                        <div className=' text-gray-600 col-span-2 '>Do you know any other plaintiffs with the same case against 
                            <br/> this person or entity, or is it just you?</div>
                            <div className={"col-span-1 " +(userInfo?.isActiveSubscription  ? '': 'blur-sm' )}>{
                            userInfo?.isActiveSubscription  ? 
                        (caseDetails?.defendant === "yes" ? "Other similar people, too" : "Just me")
                        :
                        "Test value here"}
                        </div>
                    </div>
                    }
                    {
                        caseDetails?.adversePartyNetWorth &&
                        <div className={"flex mb-4 grid grid-cols-3  gap-2 "}>
                                <div className=' text-gray-600 col-span-2'>What is the adverse party's net worth?</div>
                                <div className={"col-span-1 " +(userInfo?.isActiveSubscription  ? '': 'blur-sm' )}>{
                                userInfo?.isActiveSubscription  ?
                                (caseDetails?.adversePartyNetWorth ? getNetWorth(caseDetails?.adversePartyNetWorth) : "Not provided")
                                :
                                "Test value here"}
                                </div>
                        </div>
                    }
                    {
                        caseDetails?.adversePartyPublicCompany &&
                        <div className={"flex mb-4 grid grid-cols-3  gap-2 "}>
                                <div className=' text-gray-600 col-span-2'>Is the adverse party a public company?</div>
                                <div className={"col-span-1 " +(userInfo?.isActiveSubscription  ? '': 'blur-sm' )}>{
                                userInfo?.isActiveSubscription  ?
                                (caseDetails?.adversePartyPublicCompany === "yes" ? "Yes" : ( caseDetails?.adversePartyPublicCompany === "no" ? "No" : "Unknown"))
                                :
                                "Test value here"}
                                </div>
                        </div>
                    }
                    {
                        TEAMUP_ENABLED && caseDetails?.aiSuitability && userInfo?.isUserFunder &&
                        <div className={"flex mb-4 grid grid-cols-3  gap-2 "}>
                                <div className=' text-gray-600 col-span-2'>The Litigation funder suitability rating for this case</div>
                                <div className={"col-span-1 " +(userInfo?.isActiveSubscription  ? '': 'blur-sm' )}>{
                                userInfo?.isActiveSubscription  ?
                                (caseDetails?.aiSuitability + "/10" )
                                :
                                "Test value here"}
                                </div>
                        </div>
                    }
                   
                </div>
                
                    {
                    hasAccess ? 
                        <div className='absolute bg-green-400 p-2 rounded top-3 right-5 top-10'>
                        <MakeDownloadblePdf caseDetails={caseDetails} content={<DownloadIcon/>}/>
                        </div>
                        :
                        ""
                    }
                
        </div>
  )
}

export default RequiredInfoOnProfContent